import React from "react";
import DatePicker from "react-datepicker";
import redTimes from "src/images/red-times.svg";
// tslint:disable-next-line: no-relative-imports
import styles from "./DateInput.module.css";

import "react-datepicker/dist/react-datepicker.css";

type Props = {
  type?: string;
  value?: Date;
  error?: boolean;
  placeholder: string;
  wrapperClassName?: string;
  black?: boolean;
  handleBlur?(
    ev: React.ChangeEvent<HTMLInputElement>
  ): string | Promise<string>;
  handleChange(ev: React.ChangeEvent<HTMLInputElement>): string;
};

class Input extends React.Component<Props> {
  public render() {
    const { props } = this;
    const date =
      new Date(this.props.value) == "Invalid Date"
        ? null
        : new Date(this.props.value);
    return (
      <div
        className={`${styles.inputWrapper} ${props.black ? styles.black : ""}`}
      >
        <DatePicker
          selected={date}
          onSelect={this.handleBlur}
          placeholderText={this.props.placeholder}
          maxDate={new Date()}
          className={styles.input}
          type="date"
          dateFormat="yyyy-MM-dd"
          strictParsing
          showYearDropdown
          dropdownMode="select"
        />
        {props.error ? <img src={redTimes} alt="ошибка" /> : ""}
      </div>
    );
  }

  private handleBlur = (value: Date) => {
    this.props.handleBlur(value);
  };
}

export default Input;
